export default {"src":"/_next/static/media/instagram.bc4724fc.svg","height":50,"width":187,"blurWidth":0,"blurHeight":0};